import { useQuery } from '@tanstack/react-query';

import { SEARCH_ITEMS_PER_PAGE } from 'src/constants';
import { apiRequest } from 'src/helpers/apiRequest';
import { useAppConfig } from 'src/hooks';
import { SearchApplicationsResponsePagedList } from 'src/types/rest/managementPortalApi';

export const useSearchApplications = (name?: string) => {
  const {
    managementPortalApi: { apiHost },
  } = useAppConfig();

  const base = new URL(apiHost).origin;

  /* TODO: Consider that pageIndex and itemsPerPage could cause issues if there are too many equally named result. */
  return useQuery({
    enabled: !!name,
    queryFn: () => {
      /**
       * Build the query string via URLSearchParams so reserved characters in
       * search terms are encoded correctly.
       */
      const url = new URL('/internal/api/v1/applications/search', base);

      url.searchParams.set('pageIndex', '1');
      url.searchParams.set('itemsPerPage', SEARCH_ITEMS_PER_PAGE.toString());
      url.searchParams.set('searchTerm', name ?? '');

      return apiRequest<SearchApplicationsResponsePagedList>({
        url: url.toString(),
      });
    },
    queryKey: ['searchApplications', name],
  });
};
